const SAVE_SCAN = 'SAVE_SCAN'
const IS_SCAN_SAVED = 'IS_SCAN_SAVED'
const UPDATE_SCAN = 'UPDATE_SCAN'
const IS_SCAN_UPDATED = 'IS_SCAN_UPDATED'
const GET_SCAN_BY_ID = 'GET_SCAN_BY_ID'
const SET_SCAN_BY_ID = 'SET_SCAN_BY_ID'
const GET_ALL_SCANS = 'GET_ALL_SCANS'
const SET_ALL_SCANS = 'SET_ALL_SCANS'
const SET_FILTERS = 'SET_FILTERS'
const SET_PAGINATION_DATA = "SET_PAGINATION_DATA"
const GET_SCANS_EXCEL_EXPORT_FILE = 'GET_SCANS_EXCEL_EXPORT_FILE'
const SET_SCANS_EXCEL_EXPORT_FILE = 'SET_SCANS_EXCEL_EXPORT_FILE'

const DOWNLOAD_TEMPLATE = 'DOWNLOAD_TEMPLATE'
const SET_TEMPLATE_DATA = 'SET_TEMPLATE_DATA'

const UPLOAD_ASSETS = 'UPLOAD_ASSETS'
const IS_ASSETS_UPLOADED = 'IS_ASSETS_UPLOADED'



export {
    SAVE_SCAN,
    IS_SCAN_SAVED,
    UPDATE_SCAN,
    IS_SCAN_UPDATED,
    GET_SCAN_BY_ID,
    SET_SCAN_BY_ID,
    GET_ALL_SCANS,
    SET_ALL_SCANS,
    SET_FILTERS,
    SET_PAGINATION_DATA,
    GET_SCANS_EXCEL_EXPORT_FILE,
    SET_SCANS_EXCEL_EXPORT_FILE,
    DOWNLOAD_TEMPLATE,
    SET_TEMPLATE_DATA,
    UPLOAD_ASSETS,
    IS_ASSETS_UPLOADED
}